import NotificationItem from '@/components/NotificationItem/NotificationItem';

export default NotificationItem;
